import { render, staticRenderFns } from "./LocationSelector.vue?vue&type=template&id=80812b1e&scoped=true&"
import script from "./LocationSelector.vue?vue&type=script&lang=ts&"
export * from "./LocationSelector.vue?vue&type=script&lang=ts&"
import style0 from "./LocationSelector.vue?vue&type=style&index=0&id=80812b1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80812b1e",
  null
  
)

export default component.exports